import classNames from 'classnames'
import type { FunctionComponent } from 'react'
import { useMemo } from 'react'

import styles from './marquee-item.module.scss'
import { Markdown } from '@components/markdown'
import type { MarqueeItemFragment } from '@graphql/fragments/MarqueeFragment.graphql'

export const MarqueeItem: FunctionComponent<Props> = ({
    image,
    icon,
    copy,
    size = 'default',
    theme,
}) => {
    const imageSource = useMemo(() => {
        if (image) {
            return image.source
        } else if (icon) {
            // replcae all dashes with underscores
            const themeFilename = theme.replace(/-/g, '_')
            return `/assets/icons/${icon}_${themeFilename}.png`
        }

        return `/assets/icons/stars_future_fuscia.png`
    }, [icon, image])

    return (
        <div
            className={classNames(
                styles.card,
                size === 'large' && styles.large,
            )}
        >
            <img
                className={styles['card-image']}
                src={imageSource}
                alt={image?.alt ?? icon}
            />
            <Markdown
                markdown={copy}
                typeStyle='body-xs'
                color='dim'
                boldColor='primary'
            />
        </div>
    )
}

export default MarqueeItem

interface Props extends Omit<MarqueeItemFragment, 'sys' | 'type'> {
    size: string
    theme: string
}
